import {NavLink} from 'react-router-dom';

const links = [
  {to: '/about', label: 'About'},
  {to: '/privacy', label: 'Privacy'},
  {to: '/terms', label: 'Terms'},
  {to: '/contact', label: 'Contact'},
  {to: '/disclaimer', label: 'Disclaimer'},
];

function FooterNav() {
  return (
    <nav className="footer-nav" aria-label="Footer navigation">
      {links.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          className={({isActive}) => (isActive ? 'is-active' : '')}
        >
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
}

export default FooterNav;